import { render, staticRenderFns } from "./RichText.vue?vue&type=template&id=2cbed3c4&scoped=true&"
import script from "./RichText.vue?vue&type=script&lang=js&"
export * from "./RichText.vue?vue&type=script&lang=js&"
import style0 from "./RichText.vue?vue&type=style&index=0&id=2cbed3c4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbed3c4",
  null
  
)

export default component.exports